import { useEffect, useState } from "react";

import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { getDevice } from "../../../../../MyApi/sb/device";

import LoadingSpinner from "../../../../UI/spinner";
import PagnationComponent from "../../../../UI/pagnationComponent";
import SingleDevice from "../singleDevice";


import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";

import classes from "./deviceDataTable.module.css";

const DeviceDataTable = () => {
  const [currentPage, setcurrentPage] = useState(1);
  const{i18n}=useTranslation()
  const lang = i18n.language
  const { data, isLoading, refetch ,error } = useQuery(
    ["getdevice", currentPage,lang],
    () => getDevice(currentPage,lang)
  );

  const { t } = useTranslation();

  useEffect(() => {
    refetch();
  }, [refetch, currentPage]);
 
  const totalItems = data?.total;
  const itemsPerPage = data?.last_page;
  const devices = data?.data ||[];
  const responeMessage= data?.message
 

  if(isLoading){
    return <LoadingSpinner/>
}
 if(error){  
    return <ErrorMessage  error={error}/>
  }
  if(devices.length === 0){
    return<NoData  responeMessage={responeMessage}/>
  }
   
  if(!data){
      return <div>no data available</div>
  }
  

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="table-responsive-sm">
        <table className="table-responsive-sm table table-striped table-hover">
          <thead className={classes.tableHeader}>
            <th>#</th>
            <th>{t("Name")}</th>
            <th>mac</th>
            <th>uuid</th>
            <th>{t("Status")}</th>
          </thead>
          <tbody>
            {devices.map((Device) => (
              <SingleDevice key={Device.id} Device={Device} classes={classes} refetch={refetch}/>
            ))}
          </tbody>
        </table>
        </div>
      </div>
      <div className="d-flex justify-content-end">
          <PagnationComponent
            currentPage={currentPage}
            setCurrentPage={setcurrentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
          />
        </div>
    </div>
  );
};

export default DeviceDataTable;
